import Query from '../utils/Query';

export default class PostService {

	static get(slug, locale, params = {}) {
		return Query.get('/items/post', Object.assign({
			single: 1,
			fields: '*,content.*,owner.*,owner.avatar.private_hash',
			filter: {
				'content.slug': slug,
			}
		}, params));
	}

	static getAll(lang, params = {}) {
		return Query.get('/items/post', Object.assign({
			fields: '*,content.*',
			filter: {
				'content.language': lang
			}
		}, params));
	}
}
